import type { RequestInterface } from '~/common/types';
import { Role } from '~/roles/types';

export class RolesRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/roles';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class RolesPermissionsRequest implements RequestInterface {
  method = 'get';
  path = '/api/v1/roles/permissions';
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class CreateRoleRequest implements RequestInterface {
  method = 'post';
  path = '/api/v1/roles';
  headers: Record<string, any>;
  data: Record<string, any>;

  constructor({ token, role }: { token: string; role: Role }) {
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...role,
    };
  }
}

export class GetRoleRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    roleId,
    params,
  }: {
    token: string;
    roleId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/roles/${roleId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class UpdateRoleRequest implements RequestInterface {
  method = 'patch';
  path: string;
  headers: Record<string, any>;
  data: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    roleId,
    role,
    params,
  }: {
    token: string;
    roleId: string;
    role: Role;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/roles/${roleId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    this.data = {
      ...role,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class DeleteRoleRequest implements RequestInterface {
  method = 'delete';
  path: string;
  headers: Record<string, any>;

  constructor({ token, roleId }: { token: string; roleId: string }) {
    this.path = `/api/v1/roles/${roleId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
  }
}
